//src/app/features/auth/signUp/step-one/index.tsx
import { yupResolver } from '@hookform/resolvers/yup';
import {
  EmailIcon,
  LoginIcon,
  NameIcon,
  PasswordIcon,
  PhoneIcon,
  ZipcodeIcon,
} from 'assets/icons';
import { CheckboxInput } from 'Components/Auth/CheckboxInput/index';
import { CustomButton } from 'Components/Auth/CustomButton';
import { PasswordInput } from 'Components/Auth/PasswordInput/index';
import { PhoneNumInput } from 'Components/Auth/PhoneInput/index';
import { Stepper } from 'Components/Auth/Stepper/index';
import { TextInput } from 'Components/Auth/TextInput/index';
import HrText from 'Components/HrText';
import LanguageSelector from 'Components/Selectors/LanguageSelector';
import TimezoneSelector from 'Components/Selectors/TimezoneSelector';
import { useContext } from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { StepWizardChildProps } from 'react-step-wizard';
import { FormDataContext } from '..';
import { FormFieldsOne, initialData, validationSchema } from './formFields';

const SignUpOne: React.FC<Partial<StepWizardChildProps>> = ({ nextStep }) => {
  const navigate = useNavigate();

  const { setFormData, formData } = useContext(FormDataContext);
  const methods = useForm<FormFieldsOne>({
    resolver: yupResolver(validationSchema),
    defaultValues: formData || initialData,
  });
  const { register, handleSubmit, setValue, getValues, trigger } = methods;
  const showEmail = register('showEmail');

  const onSubmit: SubmitHandler<FormFieldsOne> = (data) => {
    if (setFormData && nextStep) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        ...data,
        signupEmail: data.showEmail ? data.signupEmail : '',
        phoneNumber: data.showEmail ? '' : data.phoneNumber,
        hearAboutUs: prevFormData.hearAboutUs || '',
      }));

      nextStep();
    }
  };

  return (
    <>
      <Stepper steps={['green', 'gray-100']} />
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="false">
          <div className="flex w-full mb-3">
            <div className="w-1/2">
              <TextInput
                name="firstName"
                label="Name"
                labelIcon={<NameIcon />}
                placeholder="First Name"
                type="text"
              />
            </div>
            <div className="w-1/2 ml-4 self-end">
              <TextInput name="lastName" placeholder="Last Name" type="text" />
            </div>
          </div>

          <div className="mb-3">
            {!getValues('showEmail') ? (
              <PhoneNumInput
                name="phoneNumber"
                label="Phone Number"
                labelIcon={<PhoneIcon />}
              />
            ) : (
              <TextInput
                name="signupEmail"
                label="Email Address"
                labelIcon={<EmailIcon />}
                placeholder="Enter your email..."
                type="text"
                autoComplete="false"
              />
            )}
            <span
              className="font-medium text-green	text-sm cursor-pointer block mb-7 mt-3"
              onClick={() => {
                setValue('showEmail', !getValues('showEmail'), {
                  shouldValidate: true,
                });
              }}
              ref={showEmail.ref}
            >
              {getValues('showEmail')
                ? 'Use phone number instead'
                : 'Use email address instead'}
            </span>
          </div>
          <div className="mb-3">
            <PasswordInput
              labelIcon={<PasswordIcon />}
              label="Password"
              name="signupPassword"
              autoComplete="new-password"
            />
          </div>
          {/* <div className="mb-3">
            <TextInput
              name="address"
              label="Address"
              placeholder="Enter your address"
              type="text"
              rules={{ required: 'required' }}
            />
          </div> */}
          {/* 
          <div className="flex gap-4 mb-3">
            <TextInput
              name="city"
              label="City"
              placeholder="Enter city"
              type="text"
              rules={{ required: 'required' }}
            />
            <TextInput
              name="zipcode"
              label="Zipcode"
              placeholder="Enter Zip Code"
              type="text"
              rules={{ required: 'required' }}
            />
          </div> */}
          {/* <div className="mb-3">
            <TimezoneSelector />
          </div> */}
          {/* <div>
            <LanguageSelector />
          </div> */}
          <div className="mt-3 mb-3">
            <CheckboxInput
              type="checkbox"
              rules={{
                validate: { checked: (v) => v === true || 'required' },
              }}
              name="terms"
              label={() => (
                <>
                  {' '}
                  Accept our{' '}
                  <a
                    href="https://accountantsonair.com/terms-services"
                    target={'_blank'}
                    className="text-green font-bold cursor-pointer"
                    rel="noreferrer"
                  >
                    Terms & Conditions
                  </a>
                </>
              )}
            ></CheckboxInput>
          </div>
          <CustomButton type="submit" text="Continue" />
          <div className=" hidden md-max:block ">
            <HrText text={`Already have an account?`} />
            <CustomButton
              type="button"
              text="Login"
              bgColor="white"
              textColor="green"
              borderColor="green"
              onClick={() => navigate('/login')}
              suffix={<LoginIcon />}
            />
          </div>
        </form>
      </FormProvider>
    </>
  );
};

export default SignUpOne;
